/**
 * One Home region failed to load (specs/home-page §7 Error row): the region shows "Couldn't load"
 * with Retry; the rest of Home is unaffected.
 */

import React, { useMemo } from 'react';
import { View, Text, Pressable, Platform } from 'react-native';
import { WEB_HOVER_TRANSITION_STYLE } from '../../../src/shared/constants/animations';
import { useTheme } from '../../../src/theme/useTheme';
import { HOME_COPY, HOME_TEST_IDS } from '../../../src/home/constants/home.constants';
import { getHomeRegionStateStyles } from './HomeRegionState.styles';

export interface HomeRegionErrorProps {
  onRetry: () => void;
  testID?: string;
}

export const HomeRegionError: React.FC<HomeRegionErrorProps> = ({
  onRetry,
  testID = HOME_TEST_IDS.regionError,
}) => {
  const theme = useTheme();
  const styles = useMemo(() => getHomeRegionStateStyles(theme), [theme]);

  return (
    <View style={styles.errorWrap} testID={testID}>
      <Text style={styles.errorTitle}>{HOME_COPY.REGION_ERROR_TITLE}</Text>
      <Pressable
        style={({ pressed, hovered }) => [
          styles.retryButton,
          Platform.select({ web: WEB_HOVER_TRANSITION_STYLE }),
          pressed && styles.retryButtonPressed,
          hovered && Platform.OS === 'web' && styles.retryButtonHover,
        ]}
        onPress={onRetry}
        accessibilityRole="button"
        accessibilityLabel={HOME_COPY.REGION_ERROR_RETRY}
        testID={`${testID}-retry`}
      >
        <Text style={styles.retryText}>{HOME_COPY.REGION_ERROR_RETRY}</Text>
      </Pressable>
    </View>
  );
};
